module.exports = __webpack_public_path__ + "img/16_15.5b3efd73.png";